<template>
  <v-dialog v-model="visible" width="unset">
    <!-- The activator button -->
    <template #activator="{on}">
      <v-btn v-on="on" color="blue" outline small>Ver matches</v-btn>
    </template>
    <!-- The content -->
    <v-card>
      <v-container fluid>
        <!-- The title with the id of the QMP -->
        <v-layout justify-center>
          <v-flex
            class="blue-grey--text headline font-weight-light"
            shrink
          >QMatchProduct {{ item.productId }}</v-flex>
        </v-layout>
        <!-- A loading flag to show when there is no item yet -->
        <v-layout v-if="loadingItems" justify-center>
          <v-flex shrink>
            <v-loading-message message="Cargando QMIs" />
          </v-flex>
        </v-layout>
        <!-- The QMIs -->
        <v-layout wrap>
          <v-flex shrink v-for="(item, index) in items" :key="index" xs12 sm6 md4 lg3 class="pa-2">
            <v-item-card comparison-dialog hide-matches-button :item="item" selectable xs />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api";
import Logger from "@/logger";

const logger = new Logger("views/matching/components/ItemCardMatchesDialog");

export default {
  components: {
    VItemCard: () => import("./ItemCard"),
    VLoadingMessage: () => import("./LoadingMessage")
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    items: [],
    loadingItems: false,
    visible: false
  }),
  watch: {
    visible() {
      if (this.visible && !this.items.length) {
        return this.getItems();
      }
    }
  },
  methods: {
    async getItems() {
      this.loadingItems = true;
      await api.similar
        .getQmp({ id: this.item.productId })
        .then(({ items }) => {
          this.items = items.map(item => ({
            ...item,
            selected: false,
            productId: this.item.productId
          }));
        })
        .catch(err => {
          logger.error(err);
          this.$notify.error("No pudimos cargar los QMIs");
        });
      this.loadingItems = false;
    }
  }
};
</script>